<header class="bg-white sticky top-0 z-50 print:hidden">
  <div class="max-w-7xl mx-auto px-3">
    <div class="flex flex-col md:flex-row md:items-center md:h-24 md:gap-6">
      <!-- Logo -->
      <a [href]="logoUrl()" class="shrink-0 h-14 flex items-center">
        <img
          ngSrc="{{ logoUrl() }}img/logo@2x.png"
          alt="Chef Ami logo"
          width="110"
          height="50"
          priority
          class="h-12 md:h-16 w-auto"
        />
      </a>

      <!-- Progress bar -->
      <nav aria-label="Checkout progress" class="flex-1 pb-4 md:pb-0">
        <div class="relative">
          <!-- Connector line (behind circles) -->
          <div
            class="absolute top-5 left-[4%] right-[4%] h-[3px]"
            aria-hidden="true"
          >
            @for (step of steps; track step.id) {
              @if (step.id < steps.length) {
                <!-- Static dashed background line -->
                <div
                  class="absolute top-0 h-full border-t-[1px] border-dashed border-mist"
                  [style.left.%]="((step.id - 1) / (steps.length - 1)) * 100"
                  [style.width.%]="100 / (steps.length - 1)"
                ></div>

                <!-- Animated solid line (only for the segment leading to current step) -->
                @if (step.id === currentStep() - 1) {
                  <div
                    class="absolute top-0 h-full bg-teal transition-all duration-500"
                    [style.left.%]="((step.id - 1) / (steps.length - 1)) * 100"
                    [style.width.%]="100 / (steps.length - 1)"
                  ></div>
                } @else if (step.id < currentStep() - 1) {
                  <!-- Already completed segments (static full lines) -->
                  <div
                    class="absolute top-0 h-full bg-teal"
                    [style.left.%]="((step.id - 1) / (steps.length - 1)) * 100"
                    [style.width.%]="100 / (steps.length - 1)"
                  ></div>
                }
              }
            }
          </div>

          <ol class="relative flex items-start justify-between">
            @for (step of steps; track step.id) {
              @let disabled = isStepDisabled(step.id);
              <li class="flex flex-col items-center z-10">
                <button
                  type="button"
                  (click)="onStepClick(step)"
                  [disabled]="disabled"
                  [attr.aria-current]="
                    currentStep() === step.id ? 'step' : null
                  "
                  [attr.aria-label]="
                    step.label +
                    (step.id < currentStep()
                      ? ' - completed'
                      : step.id === currentStep()
                        ? ' - current step'
                        : ' - not available')
                  "
                  class="flex flex-col items-center gap-2 bg-transparent border-0 p-0 transition-colors"
                  [class.cursor-not-allowed]="disabled"
                  [class.cursor-pointer]="!disabled"
                >
                  <!-- Icon/Circle -->
                  <div
                    class="flex items-center justify-center w-10 h-10 rounded-full transition-all"
                    [class.bg-lime]="!disabled && step.id <= currentStep()"
                    [class.bg-silver]="disabled || step.id > currentStep()"
                  >
                    <img
                      [ngSrc]="step.icon"
                      [width]="step.width"
                      [height]="step.height"
                      alt=""
                      aria-hidden="true"
                    />
                  </div>

                  <!-- Label -->
                  <span
                    class="text-xs md:text-sm whitespace-nowrap transition-colors text-teal"
                    aria-hidden="true"
                  >
                    {{ step.label }}
                  </span>
                </button>
              </li>
            }
          </ol>
        </div>
      </nav>
    </div>
  </div>
</header>
